import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.css']
})
export class ProgressBarComponent implements OnInit {
  @Input() maxValue: any
  @Input() progressValue: any
  @Input() colorValue: any
  @Input() showTitle: any
  @Input() progressHeight: any = '20px'
  @Input() displayPosition: any = 'content'
  @Input() unitValue: any = 'none'
  constructor() { }

  ngOnInit(): void {
  }

}
